import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_ENDPOINT } from '../../constants/constants';
import { getDateFormat, getHeader } from '../../utils/util';
import CustomCircularP from '../widgets/customCircularP';
import SendBroadcast from './SendBroadcast';

const Broadcast = () => {
    const [broadcasts, setBroadcasts] = useState([])
    const [showAdd, setShowAdd] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => { loadBroadcasts() }, [])

    function loadBroadcasts() {
        setLoading(true)
        axios.get(API_ENDPOINT + 'admin/broadcasts', getHeader()).then(res => {
            setLoading(false)
            const d = res.data
            if (d.success) setBroadcasts(d.message)
        })
    }

    const onActionDone = () => {
        setShowAdd(false)
        loadBroadcasts()
    }

    const audienceOf = (od) => {
        if (od.audience) return od.audience
        // Older rows: `emails` is the comma-separated string that was typed.
        const typed = typeof od.emails === 'string' ? od.emails.split(/[\s,;]+/).filter(Boolean).length : 0
        if (typed) return `${typed} email address${typed === 1 ? '' : 'es'}`
        return 'All trainers'
    }
    // The message is stored as HTML; show its text.
    const previewOf = (html) => {
        const div = document.createElement('div')
        div.innerHTML = html || ''
        const text = (div.textContent || '').replace(/\s+/g, ' ').trim()
        return text.length > 140 ? text.slice(0, 140) + '…' : text
    }
    // Delivery result, recorded since the send was made to report it. Rows
    // from before that have no status.
    const resultOf = (od) => {
        if (!od.status) return <span className="text-muted">—</span>
        if (od.status === 'sending') return <span className="tag tag-neutral">Sending…</span>
        if (od.status === 'notified') return <span className="tag tag-neutral">In-app only</span>
        const label = od.status === 'sent' ? `Sent ${od.sent}` : `${od.sent} sent · ${od.failed} failed`
        return (
            <span className={`tag ${od.status === 'sent' ? 'tag-success' : 'tag-danger'}`} title={od.error || ''}>
                {od.status === 'failed' ? `Failed` : label}
            </span>
        )
    }
    const sentOf = (od) => {
        const raw = od.createdOn || od.date
        if (!raw) return '—'
        const d = new Date(raw)
        return isNaN(d) ? '—' : getDateFormat(d)
    }

    return (
        <div>
            <SendBroadcast show={showAdd} onClose={() => setShowAdd(false)} onSent={onActionDone} />
            <CustomCircularP show={loading} />

            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <div style={{ flex: 1 }}>
                    <h3 style={{ margin: 0 }}>Broadcasted messages</h3>
                    <p style={{ margin: '2px 0 0', fontSize: 13 }} className="text-muted">Push announcements to trainer segments.</p>
                </div>
                <button className="btn btn-primary" onClick={() => setShowAdd(true)}>
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 11 18-5v12L3 14v-3z" /><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" /></svg>
                    Send Broadcast
                </button>
            </div>

            <div style={{ background: 'var(--color-surface)', padding: '6px 18px 12px' }}>
                <table className="table">
                    <thead>
                        <tr><th>#</th><th>Subject</th><th>Message</th><th>Audience</th><th>Result</th><th>Sent</th></tr>
                    </thead>
                    <tbody>
                        {broadcasts.map((od, i) => (
                            <tr key={od._id || i}>
                                <td className="text-muted">{i + 1}</td>
                                <td style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{od.title}</td>
                                <td className="text-muted" style={{ maxWidth: 420 }}>{previewOf(od.message)}</td>
                                <td><span className="tag tag-neutral">{audienceOf(od)}</span></td>
                                <td>
                                    {resultOf(od)}
                                    {od.error ? <div className="text-muted" style={{ fontSize: 12, marginTop: 4, maxWidth: 240 }}>{od.error}</div> : null}
                                </td>
                                <td className="text-muted" style={{ whiteSpace: 'nowrap' }}>{sentOf(od)}</td>
                            </tr>
                        ))}
                        {broadcasts.length === 0 && !loading && (
                            <tr><td colSpan={6} className="text-muted" style={{ textAlign: 'center', padding: 24 }}>No broadcasts sent yet</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Broadcast;
